import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Field} from 'src/app/_model/field';
import {EmailService} from 'src/app/_service/email.service';
import {LoadingService} from 'src/app/_service/loading.service';
import {MessageService} from 'src/app/_service/message.service';
import {Email} from 'src/app/_model/email';
import {DocumentoService} from '../../_service/documento.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-modal-contato',
  templateUrl: './modal-contato.component.html',
  styleUrls: ['./modal-contato.component.scss']
})
export class ModalContatoComponent implements OnInit {

  @ViewChild('modal')
  modal: TemplateRef<any> | null = null;

  @Input()
  codigoTemplate: string;

  formGroup: FormGroup = {} as FormGroup;
  idArquivo = '';

  mapFieldName = new Map<string, string>([
    ['nomeCompleto', 'Nome'],
    ['email', 'Email'],
    ['telefone', 'Telefone'],
    ['politicaPrivacidade', 'Aceite da Politica de Privacidade']
  ]);

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private documentService: DocumentoService,
    private loadingService: LoadingService,
    private messageService: MessageService,
    private emailService: EmailService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.getDocument();
  }


  getDocument(): void {
    const documentos = this.activatedRoute.snapshot.data['documentos'];
    this.idArquivo = documentos.find(e => e.codigo === 'PoliticaPrivacidade').idArquivo;
  }

  openModal(): void {
    this.modalService.open(this.modal, {ariaLabelledBy: 'modal-basic-title', size: 'sm'});
    this.montaForm();
  }

  closeModal(): void {
    this.modalService.dismissAll();
  }

  montaForm(): void {
    this.formGroup = this.formBuilder.group({
      nomeCompleto: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      telefone: ['', Validators.required],
      politicaPrivacidade: ['', Validators.requiredTrue]
    });
  }

  getCampo(formGroup: FormGroup, field: string): any {
    return formGroup.controls[field];
  }

  validaCampo(formGroup: FormGroup, field: string): boolean {
    return formGroup.controls[field].touched && !formGroup.controls[field].valid;
  }

  enviar(): void {
    if (!this.formGroup.valid && !this.formGroup.pending) {
      Object.keys(this.formGroup.controls).forEach(key => {
        this.formGroup.get(key)?.markAsTouched();
      });

      return;
    }

    const fields = Object.keys(this.formGroup.controls).map(key => ({
      chave: this.mapFieldName.get(key),
      value: this.formGroup.get(key)?.value
    }) as Field);

    const email = this.formGroup.get('email')?.value;
    const emailRequest: Email = {
      codigoTemplate: this.codigoTemplate,
      idArquivo: this.idArquivo,
      idEmpresa: '',
      email,
      dados: fields
    };

    this.loadingService.show();

    this.emailService.send(emailRequest).subscribe(
      res => this.enviarSucess(res),
      err => this.enviarError(err)
    );
  }

  enviarError(err: any): void {
    this.loadingService.hide();
    console.log(err);
    if (err.status === '404') {
      this.messageService.error('Não foi possível identificar o destinatário do e-mail.', 'Ocorreu um erro');
    } else {
      this.messageService.errorDefault();
    }
  }

  enviarSucess(res: any): void {
    this.loadingService.hide();
    this.closeModal();
    this.messageService.success('Sucesso', 'Contato enviada com sucesso!');
  }
}
